import { useQuery } from '@tanstack/react-query';
import { SPECIESTYPE_COLLECTION } from 'constants/gcConstants';
import { G_SPECIES_TYPES_QUERY_KEY } from 'constants/queryKeys';
import { GBase } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

/** Species types, offered on a new target. */
export const useFetchGSpeciesTypes = (enabled = true) => {
  return useQuery<GBase[]>({
    queryKey: [G_SPECIES_TYPES_QUERY_KEY],
    queryFn: () =>
      GlobalCatalogueService.FetchGReferenceCollectionData(
        SPECIESTYPE_COLLECTION
      ),
    staleTime: 1000 * 60 * 30,
    enabled,
  });
};
